import React from 'react'
import './portfolio.css'
import P1 from '../../assets/P1.jpg';
import P2 from '../../assets/P2.jpg';
import P3 from '../../assets/P3.jpg';
import P5 from '../../assets/P5.jpg';
import P6 from '../../assets/P6.jpg';
import P7 from '../../assets/P7.jpg';

const data=[
{
  id:1,
  image:P1,
  title:'netfilx clone',
  github:'https://github.com/Amanraj8969/Netflix-Clone',
  demo:'https://netflix-clone-61ba0.firebaseapp.com/'
},
{
  id:2,
  image:P2,
  title:'Musically',
  github:'https://github.com/Amanraj8969/Musically-app',
  demo:'https://muskilly.firebaseapp.com/'
},
{
  id:3,
  image:P3,
  title:' Amazon_clone',
  github:'https://github.com/Amanraj8969/Amazon_fullStack',
  demo:'https://dribble.com'
},
{
  id:4,
  image:P5,
  title:' Mern Stack Socila Pedia',
  github:'https://github.com/Amanraj8969/SocioPedia',
  demo:'https://dribble.com'
},
{
  id:5,
  image:P6,
  title:' MY Portfolio',
  github:'https://github.com/Amanraj8969/SocioPedia',
  demo:'https://dribble.com'
},
{
  id:6,
  image:P7,
  title:' Love Pedia',
  github:'https://github.com/Amanraj8969/SocioPedia',
  demo:'https://soft-kataifi-a426c6.netlify.app/'
},

]

const Portfolio=()=> {
  return (
    <section id='portfolio'>
   <h5>My Recent Project</h5>
   <h2>Portfolio</h2>
   <div className='container portfolio_contianer'>
  {
    data.map(({id,image,title,github,demo})=>{
      return(
        <article key={id} className='portfolio_item'>
        <div className='portfolio_item_image'>
         <img src={image} alt={title}/>
        </div>
        <h3>{title}</h3>
      <div  className='portfolio_item_cta'>
      <a href={github} className='btn' target='_blank'>Github</a>
        <a href={demo} className='btn btn-primary' target='_blank'>Live Demo</a>
      </div>
      
      </article>
      )
    })
  }
   
   </div>


    </section>
  )
}

export default Portfolio